import { ComponentType, ReactNode } from 'react';
import { RouteComponentProps } from 'react-router';
import { SettingsLayout } from '../../../constants/Layout';
import { Source } from '../../../constants/Source';
import { TMediaTypes } from '../../../utils/hoc/withMediaTypes/withMediaTypes.types';
import {
  ICategories,
  MediaManagerSDKPublicMediaFolder,
} from '../../../utils/hoc/withPublicMedia/withPublicMedia.types';
import {
  MediaManagerSDKAnyItem,
  MediaManagerSDKBoard,
  MediaManagerSDKFile,
  MediaManagerSDKFolder,
} from '../../../utils/media-manager-sdk';
import { IExtendedFilter } from '../ExtendedItemsFilters/ExtendedItemsFilters.types';
import { ItemClickHandler } from '../../../utils/hoc/withItemsActions/withItemsActions.types';

export enum EmptyStateType {
  SiteFilesNewDnD,
  Trash,
  Mobile,
  Purchased,
  Favorites,
  MediaFromWix,
  Shutterstock,
  Enterprise,
  Search,
  SearchBySource,
  VisitorUploads,
  NotAuthorized,
  UnknownError,
  NetworkError,
  Offline,
  Board,
}

export type TGetEmptyStateType = {
  currentFolder: IOuter['currentFolder'];
  source: IOuter['source'];
  searchQuery: IOuter['searchQuery'];
  isNotAuthorized: IOuter['isNotAuthorized'];
  isUnknownError: IOuter['isUnknownError'];
  isNetworkError: IOuter['isNetworkError'];
  isEnterprise: IOuter['isEnterprise'];
  isOffline: IOuter['isOffline'];
  location: RouteComponentProps['location'];
};

export type TEmptyStateConfig = {
  image: string;
  Title: ComponentType;
  Subtitle?: ComponentType;
  Button?: ComponentType;
  buttonProps?: IButtonProps;
};

export interface IButtonProps {
  link?: string;
  message?: string;
}

export interface IOuter {
  source: Source;
  settingsLayout: SettingsLayout;
  searchQuery?: string;
  isEnterprise?: boolean;
  isNotAuthorized?: boolean;
  isUnknownError?: boolean;
  isNetworkError?: boolean;
  isOffline?: boolean;
  currentFolder?: MediaManagerSDKFolder | MediaManagerSDKBoard;
  type?: EmptyStateType;
  className?: string;
  dataHook?: string;
  mediaTypes?: TMediaTypes;
  extendedFiltersElement?: ReactNode;
  itemsFilters?: IExtendedFilter[];
  publicMediaRootCategories?: ICategories;
  publicMediaCurrentCategory?: MediaManagerSDKPublicMediaFolder;
  items?: MediaManagerSDKAnyItem[];
  selectedItems?: MediaManagerSDKAnyItem[];
  isSecure?: boolean;
  refreshFolder?(): void;
  selectAllMediaTypes?(): void;
  clearAllExtendedFilters?(): void;
  onItemClick?: ItemClickHandler;
  isItemSelected?(id: string): boolean;
  buyItem?(item: MediaManagerSDKFile): void;
  onItemRightClick?: ItemClickHandler;
  openExpandedView?(): void;
}

export interface ISearchSubtitleOuter {
  searchQuery: string;
}

export type TConfigMapper = {
  [key: string]: TEmptyStateConfig;
};
